import {Col, Row} from "react-bootstrap";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import MDInput from "../../../components/MDInput";
import Checkbox from "@mui/material/Checkbox";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import MDButton from "../../../components/MDButton";
import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {updateCartGift} from "../../common/api/CartApi";
import {handleDefaultValues} from "../../common/Utils";
import ClearIcon from "@mui/icons-material/Clear";
import InventoryImage from "../../event/InventoryImage";


export default function InventoryGiftItem({cartItem, client, cancel, callback}) {

  const [giftCardAmount, setGiftCardAmount] = useState(0);
  const [formInvalid, setFormInvalid] = useState(false);
  const [giftCardRecipientName, setGiftCardRecipientName] = useState();
  const [giftCardRecipientEmail, setGiftCardRecipientEmail] = useState();
  const [giftCardRecipientMessage, setGiftCardRecipientMessage] = useState();
  const [sendDate, setSendDate] = useState();
  const [giftCardDeliverFuture, setGiftCardDeliverFuture] = useState(cartItem?.inventoryItem?.giftRecipient?.deliverFuture || false);
  const [giftCardInternal, setGiftCardInternal] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(cartItem?.inventoryItem?.giftRecipient)
  });

  const handleSaveGiftCartItem = (datas) => {
    let inv = {...cartItem?.inventoryItem};
    inv.giftRecipient = {...datas};
    inv.giftRecipient.sendDate = sendDate;

    let _cartItem = {...cartItem};
    _cartItem.inventoryItem = {...inv};
    let updateCartItem = {
      cartItem: _cartItem,
      inventory: {...inv}
    }
    updateCartGift(client.guid, updateCartItem).then((resp) => {
      callback(resp)
    })
  }

  return (
    <>
      <form onSubmit={handleSubmit(handleSaveGiftCartItem)} id={'giftCartItemForm'}>
        <Row>
          <Col className={'col col-main'} xs={12}>
            <div style={{
              margin: '4px',
            }}>

              <Row>
                <Col className={'col'} sm={3} xs={12}>
                  {cartItem?.inventoryItem?.imageUrl ?
                    <InventoryImage
                      sx={{
                        width: '100%',
                        height: 'auto',
                        margin: '-15px',
                      }}
                      inventory={cartItem.inventoryItem}/>
                    : <span style={{fontSize: '42px'}}><CardGiftcardIcon/></span>
                  }
                </Col>
                <Col className={'col'} sm={9} xs={12}>
                  <h5><MDButton
                    alt={"Cancel"}
                    title={"Cancel"}
                    circular
                    iconOnly
                    variant="outlined"
                    color="secondary" size={'small'}
                    className={'pull-right'}
                    onClick={(e) => {
                      cancel()
                    }}>
                    <ClearIcon/>
                  </MDButton>
                    Gift Recipient - {cartItem?.inventoryItem.name}

                  </h5>

                  <div className="form-group">
                    <label htmlFor="firstName">Recipient Name</label>
                    <MDInput
                      variant="outlined" type="text" required
                      {...register('recipientName')}
                      className="form-control" id="recipientName"
                      placeholder="Enter Recipient name"/>
                  </div>

                  <div className="form-group">
                    <label htmlFor="firstName">Recipient Email</label>
                    <MDInput
                      variant="outlined" type="email" required
                      {...register('email')}
                      className="form-control" id="email"
                      placeholder="Enter Recipient Email"/>
                  </div>


                  <div style={{
                    marginTop: '15px',
                    width: '100%'
                  }}>
                    <h6>Personal Message</h6>
                    <textarea type="text"
                              rows={5}
                              {...register('message')}
                              autoComplete="off"
                              maxLength={255}
                              name="message"
                              className="form-control" id="message"
                              placeholder="Enter Message"/>
                  </div>

                  <div style={{
                    marginTop: '15px',
                    width: '100%'
                  }}>
                    <h6>Future Gift?

                      <Checkbox checked={giftCardDeliverFuture}
                                {...register('deliverFuture', {
                                  onChange: ((e) => {
                                    setGiftCardDeliverFuture(e.target.checked)
                                  })
                                })} />
                    </h6>
                    <div className="form-group">
                      <label htmlFor="billingEndDate">Choose Scheduled Delivery Date</label>

                      <div className={'input-group d-block'}>
                        <DesktopDatePicker
                          disabled={!giftCardDeliverFuture}
                          slotProps={{
                            actionBar: {
                              actions: ['today'],
                            },
                          }}
                          {...register('sendDate')}
                          value={dayjs(sendDate)}
                          minDate={dayjs()}
                          onChange={(e) => {
                            setSendDate(new Date(e.$d));
                            let _e = {
                              target: {
                                name: 'giftCardRecipientSendDate',
                                value: new Date(e.$d)
                              }
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <MDButton size={"small"} className={"pull-right"} type={"submit"} color={"primary"}>
                    Save
                  </MDButton>
                </Col>

              </Row>

            </div>

          </Col>


        </Row>
      </form>
    </>
  )
}